import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  min-width: 200px;
  min-height: 260px;
  max-width: 200px;
  max-height: 260px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--gray-light);
  cursor: pointer;
  &:hover {
    z-index: 2;
    transform: scale(1.05);
  }
  .header-card {
    width: 100%;
    height: auto;
    min-height: 175px;
    flex-grow: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    overflow: hidden;
    padding: 7px;
    grid-gap: 7px;
    background-color: var(--blue-light);
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;

    img {
      width: 100%;
      object-fit: scale-down;
      border-radius: 3px;
    }

    .transparent-img {
      opacity: 0;
    }
  }
  .name-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name-wishlist {
      line-height: 1.3;
      font-size: 12px;
      font-weight: bold;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .footer-card {
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
  .products {
    line-height: 1.1;
    font-size: 12px;
    font-weight: 500;
    color: var(--gray-contentoh);
  }
`;
